import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import { fastContract } from '@/api/modules/product.js';
export default {
  props: {
    showAppointLink: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    productId: {
      type: String
    },
    descriptionStyle: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['list', 'haslogin'])
  },
  methods: {
    async handleAppoint() {
      const h = this.$createElement;
      if (this.haslogin) {
        fastContract({
          source: '官网',
          product_name: this.$route.meta.title
        }).then(res => {
          if (res.code === 1) {
            this.$success({
              title: '预约成功',
              content: h("div", [h("p", ["\u60A8\u7684\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u60A8\u8054\u7CFB\uFF01"]), h("p", ["\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BF9\u63A5\u7684\u540C\u82B1\u987A\u9500\u552E\u540C\u4E8B\u6216\u81F4\u75350571-88911818"])])
            });
          }
        });
      } else {
        this.$confirm({
          title: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$router.replace({
              path: '/login'
            });
          },
          centered: true
        });
      }
    },
    jumpManual() {
      this.$router.push({
        path: '/service/financial-terminal-manual'
      });
    }
  }
};